type OSApiKeyHeader = {
  'X-API-KEY': string | undefined;
};

export const getOpenSeaApiKey = (chainId?: number): OSApiKeyHeader => {
  return chainId === 1
    ? { 'X-API-KEY': process.env.REACT_APP_OPENSEA_API_KEY }
    : { 'X-API-KEY': process.env.REACT_APP_OPENSEA_API_KEY_TESTNETS };
};

export const getAlchemyApiKey = (chainId?: number): string | undefined => {
  return chainId === 1 ? process.env.REACT_APP_ALCHEMY_API_KEY : process.env.REACT_APP_ALCHEMY_API_KEY_GOERLI;
};
